export { default } from "./useLegacyArticleHeaderGet";
